var SCM = SCM || {};

SCM.SubjectBrowse = (function ($) {

    return {
        init: init
    };

    function init(){
        if ($('body').hasClass('pg_Index')) {
            bindSubjectBrowseExpand();
        }
    }

    function bindSubjectBrowseExpand() {
        var $delegateElement = $('#main');
        $delegateElement.on('click', '.js-expand-children-subjects',
            function () {
                var $childSubjectList = $(this).closest('.parent-subject');
                if ($childSubjectList.hasClass('collapsed')) {
                    $childSubjectList.removeClass('collapsed');
                } else {
                    $childSubjectList.addClass('collapsed');
                }
            }
        );
    }

})(jQuery);